"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesService = void 0;
class AgenciesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns total agencies stats information.
     * @returns AgenciesStatsResponse
     * @throws ApiError
     */
    getAgenciesStats() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/stats',
        });
    }
    /**
     * Paginate agencies information.
     * @param withStats
     * @param filtersjson
     * @param page
     * @param count
     * @returns ListAgencyResponse
     * @throws ApiError
     */
    listAgencies(withStats, filtersjson, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/',
            query: {
                'withStats': withStats,
                'filtersjson': filtersjson,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Paginate agencies information with filters and sort.
     * @param withStats
     * @param filtersjson
     * @param page
     * @param count
     * @returns ListAgencyResponse
     * @throws ApiError
     */
    getlistAgenciesWithFilters(withStats, filtersjson, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/get/list',
            query: {
                'withStats': withStats,
                'filtersjson': filtersjson,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns bulk agencies information.
     * @param ids agency uuids
     * @param parts Agency relation atributes list
     * @returns AgencyResponse
     * @throws ApiError
     */
    getBulkAgencies(ids, parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/bulk',
            query: {
                'ids[]': ids,
                'parts[]': parts,
            },
        });
    }
    /**
     * Returns agency information by id.
     * @param id agency uuid
     * @param parts Agency relation atributes list
     * @returns AgencyResponse
     * @throws ApiError
     */
    getAgency(id, parts) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}',
            path: {
                'id': id,
            },
            query: {
                'parts[]': parts,
            },
        });
    }
    /**
     * Paginates agents information of agency.
     * @param id agency uuid
     * @param withStats
     * @param page
     * @param count
     * @returns ListAgentResponse
     * @throws ApiError
     */
    getAgencyAgents(id, withStats, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/agents',
            path: {
                'id': id,
            },
            query: {
                'withStats': withStats,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Paginates creators information of agency.
     * @param id agency uuid
     * @param page
     * @param count
     * @returns ListAgencyCreatorsResponse
     * @throws ApiError
     */
    getAgencyCreators(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/creators',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
}
exports.AgenciesService = AgenciesService;
